import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { Subject, tap, takeUntil } from 'rxjs';
import { UserService } from '../../services/user.service';
import { autoCompleteRequired } from '../../validators/autocompleteRequired';
import { OraclepridgeService } from '../../services/oracle/oraclepridge.service';

@Component({
  selector: 'app-bills-multiselect-dropdown',
  templateUrl: './bills-multiselect-dropdown.component.html',
  styleUrl: './bills-multiselect-dropdown.component.scss'
})
export class BillsMultiselectDropdownComponent {


  _unsubscribe$: Subject<boolean> = new Subject()
  @Input() selectedValues: any = []
  @Input() isWholesalePage = signal<Boolean>(false)


  @Input() label:string = "Common.BillNo"
  @Output() addToList: EventEmitter<any> = new EventEmitter();

  dataSource:any[] = []
  allData:any[] = []
  timeOut:any=0

  constructor(
    private oraclepridgeService: OraclepridgeService,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.getData()
  }

  /*----------------------Functions Called from parent---------------------- */
  // setValue(data){
  //   // console.log("eventdata",data)
  //   this.userVal = `[${data.Service_Id}] - ${data.Service_Id}`;
  // }

  reset(){
    this.selectedValues = []
    this.addToList.emit([])
  }

  /*----------------------Getting Users for dropdown select---------------------- */

  onType(value: string) {
    if (value.length == 0 || value.length > 1) {
      clearTimeout(this.timeOut)
      this.timeOut = setTimeout(() => {
        this.dataSource=[]
        // Manual Serach
        this.dataSource = this.allData.filter(x => x.name
          .indexOf(value) >= 0)
      }, 1000)
    }else{
      this.dataSource=[...this.allData]
    }
  }

  getData(searchValue:string='') {
    let body:any={
      pageNo: 1,
      pageSize: 999999999,
      SentStatus: 2,
    }

    if(!this.isWholesalePage()){
      body.billNumber = 'POS'
    }
    
    this.oraclepridgeService.GetBillHeaders(body)
     .pipe(
      tap(
        (result) => {
          let customResult:any[]= []
          if(result.IsSuccess && result.Data){
            result.Data.map((i: any) => {
              customResult.push({
                _id: i.Id,
                name: i.BILL_NO,
                // photo: ''
              })
            });
            this.allData = [...customResult]
            this.dataSource = [...customResult]

          }
        }
      ),
      takeUntil(this._unsubscribe$),
    )
    .subscribe();
  }

  isSelected(data: any) {
    return this.selectedValues.findIndex((x: any) => x.Id == data.Id) > -1
  }

  /*----------------------when Choosing User---------------------- */
  selectItem($event: any) {
    this.selectedValues = $event
    let itemsIds = this.selectedValues.map((i:any)=>i._id)
    this.addToList.emit(itemsIds)
  }


  ngOnDestroy(): void {
    this._unsubscribe$.next(true)
    this._unsubscribe$.complete()
  }
}
